export default function Size() {
    return (
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.01" x="0.705078" y="0.399414" width="58.6467" height="58.6467" fill="black" />
            <path
                d="M18.4536 25.4788C15.7527 15.0613 10.3514 11.9745 8.42192 12.7463C6.49247 13.5181 3.02025 20.0771 11.1227 28.9513M17.2958 19.6914C21.1541 22.0064 24.2408 23.1639 25.0125 33.5814M6.10661 25.4788C5.33495 30.1089 9.57914 38.9831 17.2958 38.9831M25.0125 27.7939C28.0991 29.3371 31.9574 31.6523 33.8866 36.2823M12.2799 37.5828C13.0516 43.6131 23.0833 51.3298 31.9574 47.0856"
                stroke="black"
                strokeWidth="2.74713"
                strokeLinecap="round"
            />
            <path d="M15.3672 29.3369C28.4855 47.8569 44.3047 44.7702 53.5647 33.5811" stroke="black" strokeWidth="2.74713" strokeLinecap="round" />
            <path
                d="M38.1299 37.8253C38.1299 36.6678 37.7441 34.3528 36.9724 33.5811M41.9882 37.8253C41.2166 36.6678 41.9882 33.1953 43.1457 31.2661M36.5866 46.3136C36.5866 47.4711 34.786 49.6575 33.8857 50.1719M40.0591 46.3136C39.2874 47.4711 39.6732 50.9436 40.0591 51.7153M43.5316 44.7703C43.5316 45.9278 45.4607 47.8569 46.6182 48.2428"
                stroke="black"
                strokeWidth="2.74713"
                strokeLinecap="round"
            />
        </svg>
    );
}
